import { FileMetaData } from "src/app/models/FileToUpload";

import { Tool } from "./Tool";

export class PoSubmit {
  tools: Tool[];
  poNumber: string;
  comments: string;
  document: FileMetaData;
  scrap?: boolean;
  rur?: boolean;
  shipTo: string;

  commentsToShow?: string; // to show in Purchase Order after submit
}
